import LinkRootBlocks from '../../components/blocks/LinkRootBlocks.jsx';
import ROUTES from '../../routes/Routes.js';

export default function Linkroot() {
    return (
        <>
            <LinkRootBlocks
                maintitle="Selecciona un área para comenzar"
                columnsPerRow={3}
                blocks={[
                    { ico: "bi bi-building-fill", title: "Empresas", link: ROUTES.LINKROOTCOMPANY},
                    { ico: "bi bi-people-fill", title: "Usuarios", link: ROUTES.LINKROOTUSER},
                    { ico: "bi bi-currency-dollar", title: "Precios", link: ROUTES.LINKROOTPRICING},
                    { ico: "bi bi-body-text", title: "Descripciones", link: ROUTES.LINKROOT_DESCRIPTION},
                    { ico: "bi bi-server", title: "Servidor", link: ROUTES.LINKROOT_SERVER}
                ]}
            />
        </>
    );
}